module.exports = __webpack_public_path__ + "img/branding-logo-huisstijl-full-on-eventsector-1.57cd0164.jpg";